import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { createGlobalStyle, css } from 'styled-components'
import { IoIosArrowDown } from 'react-icons/io'

const CommonDropdown = ({
  className,
  name = 'searchType',
  width = 83,
  selectValue,
  options,
  onChange,
  ...props
}) => {
  return (
    <>
      <SelectIconStyle />
      <SelectWrapper
        width={width}
        className={className}
        style={{ ...props.style }}>
        <Select name={name} onChange={onChange} value={selectValue}>
          {options.map(({ text, value }) => (
            <option key={value} text={text} value={value} label={value} />
          ))}
        </Select>
        <IoIosArrowDown className="icon-arrow" />
      </SelectWrapper>
    </>
  )
}

CommonDropdown.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  selectValue: PropTypes.string,
  width: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const SelectIconStyle = createGlobalStyle`
  .icon-arrow {
    position: absolute;
    top: 15px;
    right: 10px;
    width: 15px;
    color: #ABAFB4;
  }
`

const SelectWrapper = styled.div`
  display: flex;
  position: relative;

  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}
`

const Select = styled.select`
  flex: 1;
  height: 46px;
  padding-left: 14px;
  z-index: 1;
  outline: none;
  cursor: pointer;
  border: 1px solid #eaebec;
  border-radius: 5px;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  ::-ms-expand {
    display: none;
  }
`

export default CommonDropdown
